
export const Loaderwithlogo=(props) => 
{
    return (
      <section className="register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
        <div className="loader-container"> 
          <span class="element-to-animate">
           <img src="gilogo.png" style={{ width : props.width ? props.width : '',
           height : props.height ? props.height : '' }}  />
          </span>
        </div>
        </section>
    )
}